<ul class="nav nav-pills justify-content-end">
    <li class="nav-item" role="presentation">
        <button id="nav-settings" data-bs-toggle="tab" data-bs-target="#nav-settings-pane" aria-controls="nav-settings"
            class="nav-link" [ngClass]="tradeboard.selected_class.settings" type="button"
            (click)="onTabSelected('settings')" aria-selected="true">Settings</button>
    </li>
    <li class="nav-item" role="presentation">
        <button id="nav-positions" data-bs-toggle="tab" data-bs-target="#nav-positions-pane"
            aria-controls="nav-positions" class="nav-link" [ngClass]="tradeboard.selected_class.positions" type="button"
            (click)="onTabSelected('positions')" aria-selected="false">Positions</button>
    </li>
</ul>
<div class="tab-content" id="navTabContent">
    <div class="tab-pane fade show active" id="nav-settings-pane" role="tabpanel" aria-labelledby="nav-settings"
        tabindex="0">
        <div class="container d-grid gap-3">
            <div class="row">
                <div class="col-md-2">
                    <label class="form-label">Name</label>
                    <div class="form-group">
                        <input type="text" [disabled]="tradeboard.edit_mode" class="form-control"
                            [(ngModel)]="tradeboard.name">
                    </div>
                </div>
                <div class="col-md-2">
                    <label class="form-label">Symbol</label>
                    <div class="form-group">
                        <select class="form-select" [(ngModel)]="tradeboard.params.symbol.name"
                            (change)="onSymbolSelected()">
                            <option *ngFor="let sym of symbols" [value]="sym.name">
                                {{ sym.name }}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="col-md-2">
                    <label class="form-label">Product Type</label>
                    <div class="form-group">
                        <select class="form-select" [(ngModel)]="tradeboard.params.product_type.name"
                            (change)="onProductTypeSelected()">
                            <option *ngFor="let pt of product_types" [value]="pt.name">
                                {{ pt.name }}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="col-md-2">
                    <label class="form-label">Lots</label>
                    <div class="form-group">
                        <input type="number" [step]="tradeboard.params.lot_size" [min]="tradeboard.params.min_lot_size"
                            [max]="tradeboard.params.max_lot_size" class="form-control"
                            [(ngModel)]="tradeboard.params.quantity">
                    </div>
                </div>
                <div class="col-md-4">
                    <label class="form-label"></label>
                    <div class="form-group">
                        <button class="btn btn-primary m-1 btn-sm" (click)="updateParams()">Update</button>
                        <button class="btn btn-primary m-1 btn-sm" (click)="refreshDatas()">Refresh</button>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="accordion" id="usersAccordion">
                    <div class="accordion-item">
                        <h2 class="accordion-header" id="headingUsers">
                            <button class="accordion-button" type="button" data-bs-toggle="collapse"
                                data-bs-target="#collapseUsers" aria-expanded="true" aria-controls="collapseUsers">
                                Users
                            </button>
                        </h2>
                        <div id="collapseUsers" class="accordion-collapse collapse show" aria-labelledby="headingUsers"
                            data-bs-parent="#usersAccordion">
                            <div class="accordion-body">
                                <div class="table-responsive mt-3">
                                    <table class="table align-middle">
                                        <thead class="table-secondary">
                                            <tr class="d-flex">
                                                <th class="col-md-5">Client ID</th>
                                                <th class="col-md-5">Lots</th>
                                                <th class="col-md-2">
                                                    Action
                                                    <i class="bi bi-plus-square-fill position-relative start-50"
                                                        (click)="addUser()" style="font-size: 1rem;"></i>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let user of tradeboard.users; let i = index;" class="d-flex"
                                                ng-if="tradeboard.users.length > 0">
                                                <td class="col-md-5">
                                                    <select class="form-select" [(ngModel)]="user.broker_acc_id"
                                                        (change)="onClientIDSelected(user)">
                                                        <option *ngFor="let ba of user.bas" [value]="ba._id">
                                                            {{ ba.params.client_id }}
                                                        </option>
                                                    </select>
                                                </td>
                                                <td class="col-md-5">
                                                    <input type="number" [step]="tradeboard.params.lot_size"
                                                        [min]="tradeboard.params.min_lot_size"
                                                        [max]="tradeboard.params.max_lot_size" class="form-control"
                                                        [(ngModel)]="user.quantity">
                                                </td>
                                                <td class="col-md-2">
                                                    <button class="btn btn-secondary btn-sm"
                                                        (click)="deleteUser(i, user)" aria-label="trash">
                                                        <i class="bi bi-trash-fill ms-0" style="color:white" aria-hidden="true"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr class="d-flex" *ngIf="tradeboard.users.length == 0">
                                                <td colspan="6" class="col-md-12 text-center">No Users Found</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="accordion" id="contractsAccordion">
                    <div class="accordion-item">
                        <h2 class="accordion-header" id="headingContracts">
                            <button class="accordion-button" type="button" data-bs-toggle="collapse"
                                data-bs-target="#collapseContracts" aria-expanded="true" aria-controls="collapseContracts">
                                Contracts
                            </button>
                        </h2>
                        <div id="collapseContracts" class="accordion-collapse collapse show" aria-labelledby="headingContracts"
                            data-bs-parent="#contractsAccordion">
                            <div class="accordion-body">
                                <div class="table-responsive mt-3">
                                    <table class="table align-middle">
                                        <thead class="table-secondary">
                                            <tr class="d-flex">
                                                <th class="col-md-2">Strike</th>
                                                <th class="col-md-2">CE/PE</th>
                                                <th class="col-md-2">Order Type</th>
                                                <th class="col-md-2">Price</th>
                                                <th class="col-md-2">Trg. Price</th>
                                                <th class="col-md-2">
                                                    Action
                                                    <i class="bi bi-plus-square-fill position-relative start-50"
                                                        (click)="addContracts()" style="font-size: 1rem;"></i>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let contract of tradeboard.contracts; let idx = index" class="d-flex"
                                                ng-if="tradeboard.contracts.length > 0">
                                                <td class="col-md-2">
                                                    <input type="number" [step]="tradeboard.params.strike_diff"
                                                        class="form-control" [(ngModel)]="contract.strike">
                                                </td>
                                                <td class="col-md-2">
                                                    <select class="form-select" [(ngModel)]="contract.option_type.name"
                                                        (change)="onOptionTypeSelected(contract)">
                                                        <option *ngFor="let opt of option_types" [value]="opt.name">
                                                            {{ opt.name }}
                                                        </option>
                                                    </select>
                                                </td>
                                                <td class="col-md-2">
                                                    <select class="form-select" [(ngModel)]="contract.order_type.name"
                                                        (change)="onOrderTypeSelected(contract)">
                                                        <option *ngFor="let ot of order_types" [value]="ot.name">
                                                            {{ ot.name }}
                                                        </option>
                                                    </select>
                                                </td>
                                                <td class="col-md-2">
                                                    <input type="number" step="0.05" min="0.05" class="form-control"
                                                        [disabled]="!contract.price_enabled" [(ngModel)]="contract.price">
                                                </td>
                                                <td class="col-md-2">
                                                    <input type="number" step="0.05" min="0.05" class="form-control"
                                                        [disabled]="!contract.trigger_price_enabled"
                                                        [(ngModel)]="contract.trigger_price">
                                                </td>
                                                <td class="col-md-2">
                                                    <button class="btn btn-success m-1 btn-sm"
                                                        (click)="placeOrder(contract, 'buy')">B</button>
                                                    <button class="btn btn-danger m-1 btn-sm"
                                                        (click)="placeOrder(contract, 'sell')">S</button>
                                                    <button class="btn btn-secondary btn-sm"
                                                        (click)="deleteContract(idx, contract)" aria-label="trash">
                                                        <i class="bi bi-trash-fill ms-0" style="color:white" aria-hidden="true"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr class="d-flex" *ngIf="tradeboard.contracts.length == 0">
                                                <td colspan="6" class="col-md-12 text-center">No Contracts Found</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="accordion" id="tgtSLAccordion">
                    <div class="accordion-item">
                        <h2 class="accordion-header" id="headingTgtSL">
                            <button class="accordion-button" type="button" data-bs-toggle="collapse"
                                data-bs-target="#collapseTgtSL" aria-expanded="true" aria-controls="collapseTgtSL">
                                Tgt & SL
                            </button>
                        </h2>
                        <div id="collapseTgtSL" class="accordion-collapse collapse show" aria-labelledby="headingTgtSL"
                            data-bs-parent="#tgtSLAccordion">
                            <div class="accordion-body">
                                <div class="container d-grid gap-3">
                                    <div class="row">
                                        <div class="col-md-3">
                                            <label class="form-label">No. of Tgts</label>
                                            <div class="form-group">
                                                <input type="number" step="1" class="form-control" [(ngModel)]="tradeboard.tgt.total">
                                            </div>
                                        </div>
                                        <div class="col-md-3">
                                            <label class="form-label">Type</label>
                                            <div class="form-group">
                                                <select class="form-select" [(ngModel)]="tradeboard.tgt.type.name"
                                                    (change)="onTargetTypeSelected()">
                                                    <option *ngFor="let tt of tgt_types" [value]="tt.name">
                                                        {{ tt.name }}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-md-3">
                                            <label class="form-label">Value</label>
                                            <div class="form-group">
                                                <input type="number" class="form-control" [(ngModel)]="tradeboard.tgt.step_value">
                                            </div>
                                        </div>
                                        <div class="col-md-3">
                                            <label class="form-label">Lot Allocation</label>
                                            <div class="form-group">
                                                <select class="form-select" [(ngModel)]="tradeboard.tgt.lot_allocation.name"
                                                    (change)="onTgtLotAllocationSelected()">
                                                    <option *ngFor="let lat of lot_alloc_types" [value]="lat.name">
                                                        {{ lat.name }}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-3">
                                            <label class="form-label">No. of SL</label>
                                            <div class="form-group">
                                                <input type="number" step="1" class="form-control" [(ngModel)]="tradeboard.sl.total">
                                            </div>
                                        </div>
                                        <div class="col-md-3">
                                            <label class="form-label">Type</label>
                                            <div class="form-group">
                                                <select class="form-select" [(ngModel)]="tradeboard.sl.type.name"
                                                    (change)="onSLTypeSelected()">
                                                    <option *ngFor="let st of sl_types" [value]="st.name">
                                                        {{ st.name }}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-md-3">
                                            <label class="form-label">Value</label>
                                            <div class="form-group">
                                                <input type="number" class="form-control" [(ngModel)]="tradeboard.sl.step_value">
                                            </div>
                                        </div>
                                        <div class="col-md-3">
                                            <label class="form-label">Lot Allocation</label>
                                            <div class="form-group">
                                                <select class="form-select" [(ngModel)]="tradeboard.sl.lot_allocation.name"
                                                    (change)="onSLLotAllocationSelected()">
                                                    <option *ngFor="let lat of lot_alloc_types" [value]="lat.name">
                                                        {{ lat.name }}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <!-- <div class="col-md-3">
                                            <div class="form-check">
                                                <input class="form-check-input" type="checkbox" [checked]="tradeboard.tsl.enabled" value="" id="tslEnableCheck">
                                                <label class="form-check-label" for="tslEnableCheck">
                                                  TSL
                                                </label>
                                              </div>
                                        </div> -->
                                        <div class="col-md-3">
                                            <div class="form-check">
                                                <input class="form-check-input" type="checkbox" [(ngModel)]="tradeboard.tsl.enabled" value=""
                                                id="tslEnableCheck">
                                                <label class="form-check-label" for="tslEnableCheck">
                                                  TSL
                                                </label>
                                            </div>
                                            <div class="form-group">
                                                <select class="form-select" [(ngModel)]="tradeboard.tsl.type.name"
                                                    (change)="onTSLTypeSelected()" [disabled]="!tradeboard.tsl.enabled">
                                                    <option *ngFor="let tst of tsl_types" [value]="tst.name">
                                                        {{ tst.name }}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-md-3">
                                            <label class="form-label">Trail Mechanism</label>
                                            <div class="form-group">
                                                <select class="form-select" [(ngModel)]="tradeboard.tsl.mechanism.name"
                                                    (change)="onTSLMechanismSelected()" [disabled]="!tradeboard.tsl.enabled">
                                                    <option *ngFor="let tslm of tsl_mechanisms" [value]="tslm.name">
                                                        {{ tslm.name }}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <div class="card">
                    <div class="card-body d-flex flex-row-reverse">
                        <button class="btn btn-success m-1 btn-sm" (click)="saveDetails()">Save</button>
                        <button class="btn btn-danger m-1 btn-sm" (click)="closeTradeboard()">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="tab-pane fade show" id="nav-positions-pane" role="tabpanel" aria-labelledby="nav-positions"
        tabindex="1">
        <div class="row" *ngFor="let user_position of user_positions">
            <div class="accordion" id="userAccordion">
                <div class="accordion-item">
                    <h2 class="accordion-header" [attr.id]="user_position.accordion_heading">
                        <button class="accordion-button" type="button" data-bs-toggle="collapse" (click)="onAccordionItemClick(user_position)"
                            [ngClass]="user_position.collapse" [attr.data-bs-target]="user_position.accordion_tgt_id" aria-expanded="true" [attr.aria-controls]="user_position.accordion_id">
                            {{ user_position['user']['client_id'] }}
                        </button>
                    </h2>
                    <div [attr.id]="user_position.accordion_id" class="accordion-collapse collapse" [ngClass]="user_position.selected" [attr.aria-labelledby]="user_position.accordion_heading"
                        data-bs-parent="#userAccordion">
                        <div class="accordion-body">
                            <div class="table-responsive mt-3">
                                <table class="table align-middle">
                                    <thead class="table-secondary">
                                        <tr class="d-flex">
                                            <th class="col-md-2">Type</th>
                                            <th class="col-md-4">Instrument</th>
                                            <th class="col-md-2">Qty</th>
                                            <th class="col-md-4">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let position of user_position['positions']" class="d-flex" ng-if="user_position.positions.length > 0">
                                            <td class="col-md-2">
                                                {{ position.type }}
                                            </td>
                                            <td class="col-md-4">
                                                {{ position.symbol }} / {{ position.strike }}
                                            </td>
                                            <td class="col-md-2">
                                                {{ position.net_qty }}
                                            </td>
                                            <td class="col-md-4">
                                                <button class="btn btn-success m-1 btn-sm"
                                                    (click)="placeExitOrder(user_position, position, 'tgt')">Tgt</button>
                                                <button class="btn btn-danger m-1 btn-sm"
                                                    (click)="placeExitOrder(user_position, position, 'sl')">SL</button>
                                            </td>
                                        </tr>
                                        <tr class="d-flex" *ngIf="user_position['positions'].length == 0">
                                            <td colspan="6" class="col-md-12 text-center">No Open Positions</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="modal fade" id="addUserAlertModal" tabindex="-1" aria-labelledby="addUserAlertModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="addUserAlertModalLabel">Alert</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <p>No Users Available to add.</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="closeAddUserAlertModal()">OK</button>
        </div>
      </div>
    </div>
  </div>